<template>
  <div :class="sectionClass">
    <label :for="id" class="form-label">{{ label }}</label>
    <div class="p-inputgroup">
      <InputNumber
        :id="id"
        :useGrouping="false"
        :modelValue="modelValue"
        :disabled="disabled"
        :placeholder="placeholder"
        :min="min"
        :max="max"
        :minFractionDigits="2"
        :maxFractionDigits="2"
        :class="{
          'p-invalid': validation && validation.$error,
        }"
        :aria-describedby="`${id}-help`"
        @input="$emit('update:modelValue', $event.value)"
      />
      <span
        class="p-inputgroup-addon"
        :class="{
          'invalid-icon': validation?.$error,
        }"
      >
        <i class="pi pi-percentage" style="color: #fff"></i>
      </span>
    </div>
    <span
      v-if="
        validation.$error && validation.required && validation.required.$invalid
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.required.$message.replace("Value", this.label) }}
    </span>
    <span
      v-else-if="
        validation &&
        validation.$error &&
        validation.minValue.$invalid &&
        validation.minValue
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.minValue.$message }}
    </span>
    <span
      v-else-if="
        validation &&
        validation.$error &&
        validation.maxValue.$invalid &&
        validation.maxValue
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.maxValue.$message }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    labelClass: {
      type: String,
      default: "form-label",
    },
    sectionClass: {
      type: String,
      default: "field",
    },
    id: {
      type: String,
      required: true,
      default: "",
    },
    label: {
      type: String,
      required: true,
      default: "",
    },
    validation: {
      type: Object,
      required: true,
    },
    minlength: {
      type: String,
      default: "",
    },
    maxlength: {
      type: String,
      default: "",
    },
    modelValue: {
      type: Number,
      default: 0,
    },
    placeholder: {
      type: String,
      default: "",
    },
    validated: {
      type: Boolean,
      default: false,
    },
    min: {
      type: Number,
      default: null,
    },
    max: {
      type: Number,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
